import type { ColDef, ColGroupDef, GridOptions } from '@ag-grid-community/core';

/**
 * User Report Column Definitions
 * Column configuration for user device session reports with Gopher Buddy and Admin Console data
 */
export const USER_REPORT_COLUMN_DEFS: (ColDef | ColGroupDef)[] = [
  // Serial Number - hidden but used for row grouping
  {
    headerName: 'Serial Number',
    field: 'serialNumber',
    rowGroup: true,
    hide: true,
  },
  // Reported by Gopher Buddy section
  {
    headerName: 'Reported by Gopher Buddy',
    headerClass: 'custom-header',
    children: [
      {
        headerName: 'Session Start',
        field: 'sessionStart',
        width: 170,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Session Duration',
        field: 'sessionDuration',
        width: 100,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Session Private IP',
        field: 'sessionPrivateIp',
        width: 140,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Session Public IP',
        field: 'sessionPublicIp',
        width: 140,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'OS Version',
        field: 'osVersion',
        width: 150,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Device OU Path',
        field: 'deviceOuPath',
        width: 150,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
    ],
  },
  // Admin Console Values section
  {
    headerName: 'Admin Console Values',
    headerClass: 'custom-header',
    children: [
      {
        headerName: 'Recentness of use',
        field: 'recentnessOfUse',
        width: 130,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'OU Path',
        field: 'ouPath',
        width: 250,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Annotated User',
        field: 'annotatedUser',
        width: 200,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
      {
        headerName: 'Annotated Location',
        field: 'annotatedLocation',
        width: 200,
        headerClass: 'custom-header',
        cellClass: 'custom-cell',
      },
    ],
  },
];

/**
 * User Report Grid Options
 * Grid configuration for user device session reports with row grouping
 */
export const USER_REPORT_GRID_OPTIONS: GridOptions = {
  animateRows: true,
  groupDefaultExpanded: 0, // Start collapsed
  defaultColDef: {
    resizable: true,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  },
  overlayNoRowsTemplate:
    '<span class="ag-overlay-no-rows-center">No Gopher Buddy sessions found for this user</span>',
  autoGroupColumnDef: {
    headerName: 'Serial Number',
    width: 250,
    pinned: 'left',
    lockPosition: true,
    cellRendererParams: {
      suppressCount: true,
    },
    headerClass: 'serial-number-header',
    cellClass: 'serial-number-cell',
    suppressColumnsToolPanel: true,
  },
  suppressAggFuncInHeader: true,
};
